// Wait for DOM to be ready before initializing
document.addEventListener('DOMContentLoaded', function() {
	// Complete Pricing Data with Speed Options
	const PRICING = {
	  operators: {
		'36': {
		  '1SSO': {
			'Left': { cost: 2232.57, sellPrice: 2782.57, sku: 'MEP-CDO-79-31-0008' },
			'Right': { cost: 2232.57, sellPrice: 2782.57, sku: 'MEP-CDO-79-31-0002' }
		  },
		  '2SSO': {
			'Left': { cost: 2363.20, sellPrice: 2963.20, sku: 'MEP-CDO-79-31-0005' },
			'Right': { cost: 2363.20, sellPrice: 2963.20, sku: 'MEP-CDO-79-31-0006' }
		  },
		  'Center': {
			'Center': { cost: 2537.09, sellPrice: 3187.09, sku: 'MEP-CDO-79-31-0013' }
		  }
		},
		'42': {
		  '1SSO': {
			'Left': { cost: 2277.39, sellPrice: 2877.39, sku: 'MEP-CDO-79-31-0001' },
			'Right': { cost: 2277.39, sellPrice: 2877.39, sku: 'MEP-CDO-79-31-0007' }
		  },
		  '2SSO': {
			'Left': { cost: 2363.23, sellPrice: 3013.23, sku: 'MEP-CDO-79-31-0003' },
			'Right': { cost: 2363.23, sellPrice: 3013.23, sku: 'MEP-CDO-79-31-0004' }
		  },
		  'Center': {
			'Center': { cost: 2469.86, sellPrice: 3169.86, sku: 'MEP-CDO-79-31-0009' }
		  }
		},
		'48': {
		  '2SSO': {
			'Left': { cost: 2363.20, sellPrice: 3013.20, sku: 'MEP-CDO-79-31-0011' },
			'Right': { cost: 2363.20, sellPrice: 3013.20, sku: 'MEP-CDO-79-31-0010' }
		  },
		  'Center': {
			'Center': { cost: 2581.81, sellPrice: 3281.81, sku: 'MEP-CDO-79-31-0012' }
		  }
		}
	  },
	  hallTracks: {
		'36': {
		  '1SSO': {
			'Left': { cost: 207.38, sellPrice: 307.38, sku: 'MEP-LM-74-31-0003' },
			'Right': { cost: 207.38, sellPrice: 307.38, sku: 'MEP-LM-74-31-0004' }
		  },
		  '2SSO': {
			'Left': { cost: 293.26, sellPrice: 443.26, sku: 'MEP-LM-74-31-0008' },
			'Right': { cost: 293.26, sellPrice: 443.26, sku: 'MEP-LM-74-31-0007' }
		  },
		  'Center': {
			'Center': { cost: 357.96, sellPrice: 557.96, sku: 'MEP-LM-74-31-0009' }
		  }
		},
		'42': {
		  '1SSO': {
			'Left': { cost: 226.44, sellPrice: 351.44, sku: 'MEP-LM-74-31-0001' },
			'Right': { cost: 226.44, sellPrice: 351.44, sku: 'MEP-LM-74-31-0002' }
		  },
		  '2SSO': {
			'Left': { cost: 293.63, sellPrice: 468.63, sku: 'MEP-LM-74-31-0006' },
			'Right': { cost: 293.63, sellPrice: 468.63, sku: 'MEP-LM-74-31-0005' }
		  },
		  'Center': {
			'Center': { cost: 369.48, sellPrice: 569.48, sku: 'MEP-LM-74-31-0010' }
		  }
		},
		'48': {
		  '2SSO': {
			'Left': { cost: 357.33, sellPrice: 532.33, sku: 'MEP-LM-74-31-0013' },
			'Right': { cost: 357.33, sellPrice: 532.33, sku: 'MEP-LM-74-31-0012' }
		  },
		  'Center': {
			'Center': { cost: 388.16, sellPrice: 588.16, sku: 'MEP-LM-74-31-0011' }
		  }
		}
	  }
	};

	// US States
	const US_STATES = [
	  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
	  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
	  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
	  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
	  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
	];

	// State
	let state = {
	  step: 1,
	  jobName: '',
	  jobNumber: '',
	  city: '',
	  state: 'NY',
	  clientName: '',
	  company: '',
	  email: '',
	  phone: '',
	  numOpenings: 1,
	  openings: [{ width: '', speed: '', handing: '', hallLandingKits: '' }]
	};

	// Calculate pricing - each opening has its own hallLandingKits
	function calculatePricing() {
	  let total = 0;
	  let totalCost = 0;
	  const openingResults = [];
	  
	  state.openings.forEach((opening, idx) => {
		if (!opening.width || !opening.speed || !opening.handing || !opening.hallLandingKits) return;
		
		const kits = parseInt(opening.hallLandingKits) || 0;
		if (kits <= 0) return;
		
		const op = PRICING.operators[opening.width]?.[opening.speed]?.[opening.handing];
		const ht = PRICING.hallTracks[opening.width]?.[opening.speed]?.[opening.handing];
		
		if (!op || !ht) return;
		
		const opPrice = op.sellPrice;
		const htTotal = ht.sellPrice * kits;
		const openingTotal = opPrice + htTotal;
		
		const opCost = op.cost;
		const htCost = ht.cost * kits;
		const openingCost = opCost + htCost;
		
		total += openingTotal;
		totalCost += openingCost;
		
		openingResults.push({
		  num: idx + 1,
		  width: opening.width,
		  speed: opening.speed,
		  handing: opening.handing,
		  kits: kits,
		  opPrice,
		  htTotal,
		  total: openingTotal,
		  cost: openingCost
		});
	  });
	  
	  return {
		total,
		openings: openingResults,
		cost: totalCost,
		profit: total - totalCost,
		margin: total > 0 ? ((total - totalCost) / total * 100) : 0
	  };
	}

	// Get available speeds
	function getAvailableSpeeds(width, handing) {
	  if (handing === 'Center') return ['Center'];
	  const speeds = [];
	  if (PRICING.operators[width]?.['1SSO']?.[handing]) speeds.push('1SSO');
	  if (PRICING.operators[width]?.['2SSO']?.[handing]) speeds.push('2SSO');
	  return speeds;
	}

	// Format number with commas
	function formatPrice(price) {
	  return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}

	// Validate email format
	function validateEmail(email) {
	  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	  return emailRegex.test(email);
	}

	// Validate step — Step 1 = EQUIPMENT, Step 2 = INFO
	function validateStep(stepNum) {
	  if (stepNum === 1) {
		return state.openings.every(o => 
		  o.width && 
		  o.speed && 
		  o.handing && 
		  o.hallLandingKits && 
		  parseInt(o.hallLandingKits) > 0
		);
	  }
	  if (stepNum === 2) {
		const emailValid = state.email && validateEmail(state.email);
		if (!emailValid && state.email) {
		  alert('Please enter a valid email address (e.g., name@example.com)');
		  return false;
		}
		return state.jobName && state.city && state.state && state.clientName && state.company && emailValid && state.phone;
	  }
	  return true;
	}

	// Update openings
	function setNumOpenings(num) {
	  const n = parseInt(num);
	  while (state.openings.length < n) {
		state.openings.push({ width: '', speed: '', handing: '', hallLandingKits: '' });
	  }
	  if (state.openings.length > n) {
		state.openings = state.openings.slice(0, n);
	  }
	  state.numOpenings = n;
	  render();
	}

	function updateOpening(idx, field, value) {
	  const opening = state.openings[idx];
	  opening[field] = value;
	  
	  // Handle speed changes when hand changes
	  if (field === 'handing') {
		if (value === 'Center') {
		  opening.speed = 'Center';
		} else {
		  if (opening.speed === 'Center') {
			opening.speed = '';
		  }
		  const availableSpeeds = getAvailableSpeeds(opening.width || '36', value);
		  if (opening.speed && !availableSpeeds.includes(opening.speed)) {
			opening.speed = '';
		  }
		}
	  }
	  
	  // Handle width changes
	  if (field === 'width') {
		const availableSpeeds = getAvailableSpeeds(value, opening.handing || 'Left');
		if (opening.speed && !availableSpeeds.includes(opening.speed)) {
		  opening.speed = '';
		}
	  }
	  
	  render();
	}

	// Navigation
	window.nextStep = function() {
	  if (!validateStep(state.step)) {
		alert('Please fill in all required fields');
		return;
	  }
	  if (state.step < 2) {
		state.step++;
		render();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  }
	};

	window.prevStep = function() {
	  if (state.step > 1) {
		state.step--;
		render();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  }
	};

	window.setNumOpenings = setNumOpenings;
	window.updateOpening = updateOpening;

	// Submit
	window.submitEstimate = async function() {
	  const pricing = calculatePricing();
	  const submitBtn = document.querySelector('button[onclick="submitEstimate()"]');
	  
	  if (!submitBtn) return;
	  
	  submitBtn.disabled = true;
	  submitBtn.innerHTML = '<span style="display: inline-block; width: 20px; height: 20px; border: 3px solid white; border-top-color: transparent; border-radius: 50%; animation: spin 0.8s linear infinite;"></span> Submitting...';
	  
	  // Format data to match backend expectations with detailed lineItems
	  const payload = {
		formData: {
		  ...state,
		  date: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
		},
		pricing: {
		  frontend: {
			totalPrice: pricing.total.toFixed(2),
			lineItems: pricing.openings.flatMap((op, idx) => {
			  const hallTrackPrice = op.htTotal / op.kits;
			  const opData = PRICING.operators[op.width][op.speed][op.handing];
			  const htData = PRICING.hallTracks[op.width][op.speed][op.handing];
			  return [
				// Operator line item
				{
				  type: 'cab',
				  index: idx + 1,
				  description: `${op.width}" ${op.handing} Hand - ${op.speed === 'Center' ? 'SSCO' : op.speed} Operator`,
				  sku: opData.sku,
				  quantity: 1,
				  unitPrice: op.opPrice.toFixed(2),
				  totalPrice: op.opPrice.toFixed(2)
				},
				// Hall tracks line item
				{
				  type: 'hall',
				  index: idx + 1,
				  description: `${op.width}" ${op.handing} Hand - ${op.speed === 'Center' ? 'SSCO' : op.speed} Hall Landing Kits`,
				  sku: htData.sku,
				  quantity: op.kits,
				  unitPrice: hallTrackPrice.toFixed(2),
				  totalPrice: op.htTotal.toFixed(2)
				}
			  ];
			})
		  },
		  backend: {
			totalCost: pricing.cost.toFixed(2),
			totalProfit: pricing.profit.toFixed(2),
			margin: pricing.margin.toFixed(2),
			lineItems: pricing.openings.flatMap((op, idx) => {
			  const hallTrackPrice = op.htTotal / op.kits;
			  const hallTrackCost = (op.cost - PRICING.operators[op.width][op.speed][op.handing].cost) / op.kits;
			  const opCost = PRICING.operators[op.width][op.speed][op.handing].cost;
			  const opData = PRICING.operators[op.width][op.speed][op.handing];
			  const htData = PRICING.hallTracks[op.width][op.speed][op.handing];
			  const opProfit = op.opPrice - opCost;
			  const hallTrackProfit = hallTrackPrice - hallTrackCost;
			  
			  return [
				// Operator line item
				{
				  type: 'cab',
				  index: idx + 1,
				  size: op.width,
				  hand: op.handing,
				  openingType: op.speed === 'Center' ? 'SSCO' : op.speed,
				  sku: opData.sku,
				  quantity: 1,
				  unitCost: opCost.toFixed(2),
				  unitPrice: op.opPrice.toFixed(2),
				  unitProfit: opProfit.toFixed(2),
				  totalCost: opCost.toFixed(2),
				  totalPrice: op.opPrice.toFixed(2),
				  totalProfit: opProfit.toFixed(2)
				},
				// Hall tracks line item
				{
				  type: 'hall',
				  index: idx + 1,
				  size: op.width,
				  hand: op.handing,
				  openingType: op.speed === 'Center' ? 'SSCO' : op.speed,
				  sku: htData.sku,
				  quantity: op.kits,
				  unitCost: hallTrackCost.toFixed(2),
				  unitPrice: hallTrackPrice.toFixed(2),
				  unitProfit: hallTrackProfit.toFixed(2),
				  totalCost: (hallTrackCost * op.kits).toFixed(2),
				  totalPrice: op.htTotal.toFixed(2),
				  totalProfit: (hallTrackProfit * op.kits).toFixed(2)
				}
			  ];
			})
		  }
		}
	  };
	  
	  try {
		const response = await fetch('https://master-elevator-doors.vercel.app/api/submit-order', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify(payload)
		});
		
		if (response.ok) {
		  alert('✅ Request submitted successfully! We\'ll send your detailed estimate to your email shortly.');
		  state = {
			step: 1,
			jobName: '',
			jobNumber: '',
			city: '',
			state: 'NY',
			clientName: '',
			company: '',
			email: '',
			phone: '',
			numOpenings: 1,
			openings: [{ width: '', speed: '', handing: '', hallLandingKits: '' }]
		  };
		  render();
		} else {
		  throw new Error('Submission failed');
		}
	  } catch (error) {
		console.error('Error:', error);
		alert('❌ There was an error submitting your request. Please try again or contact us directly.');
		submitBtn.disabled = false;
		submitBtn.innerHTML = 'Submit Request';
	  }
	};

	// Render
	function render() {
	  // Save currently focused element to restore after re-render
	  const activeElementId = document.activeElement ? document.activeElement.id : null;
	  const activeElementValue = document.activeElement && document.activeElement.tagName === 'INPUT' 
		? document.activeElement.value 
		: null;
	  
	  const pricing = calculatePricing();
	  
	  // Check if equipment is configured (for showing review summary)
	  const isEquipmentConfigured = state.openings.every(o => 
		o.width && o.speed && o.handing && o.hallLandingKits && parseInt(o.hallLandingKits) > 0
	  );

	  // Check if info is filled (for submit button on step 2)
	  const isInfoComplete = state.jobName && state.city && state.state && state.clientName && state.company && state.email && state.phone;
	  
	  const html = `
		<style>
		  @keyframes spin {
			to { transform: rotate(360deg); }
		  }
		  
		  /* Mobile-responsive grid classes */
		  .form-grid {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 16px;
		  }
		  
		  .equipment-grid {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			gap: 16px;
		  }
		  
		  @media (max-width: 768px) {
			.form-grid {
			  grid-template-columns: 1fr;
			}
			
			.equipment-grid {
			  grid-template-columns: 1fr 1fr;
			}
		  }
		  
		  @media (max-width: 480px) {
			.equipment-grid {
			  grid-template-columns: 1fr;
			}
		  }
		</style>
		<div style="max-width: 900px; margin: 0 auto; padding: 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
		  <div style="background: white; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1); overflow: hidden;">
			
			<!-- Step Indicator -->
			<div style="display: flex; background: #f8f9fa; border-bottom: 3px solid #e9ecef;">
			  ${[
				{ num: 1, label: 'EQUIPMENT' },
				{ num: 2, label: 'INFO' }
			  ].map((step, idx) => `
				<div style="flex: 1; text-align: center; padding: 20px 10px; position: relative; background: ${state.step === step.num ? '#ff6b35' : '#f8f9fa'}; color: ${state.step === step.num ? 'white' : '#6c757d'}; font-weight: ${state.step === step.num ? 'bold' : 'normal'}; font-size: 18px; transition: all 0.3s; ${state.step > step.num ? 'opacity: 0.7;' : ''}">
				  <div style="font-size: 14px; opacity: 0.8; margin-bottom: 4px;">Step ${step.num}</div>
				  <div>${step.label}</div>
				  ${state.step === step.num ? `<div style="position: absolute; bottom: 0; left: 0; right: 0; height: 3px; background: #ff6b35;"></div>` : ''}
				</div>
			  `).join('')}
			</div>

			<div style="padding: 40px; padding: clamp(20px, 5vw, 40px);">

			  ${state.step === 1 ? `
				<h2 style="font-size: 28px; font-weight: bold; margin-bottom: 24px; color: #212529;">Equipment Configuration</h2>
				
				<div style="background: #fff3e0; border: 2px solid #ffb74d; border-radius: 8px; padding: 16px; margin-bottom: 20px;">
				  <label style="display: block; font-weight: bold; margin-bottom: 12px; font-size: 16px;">Number of Cab Openings</label>
				  <select onchange="setNumOpenings(this.value)" style="width: 100%; padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
					<option value="1" ${state.numOpenings === 1 ? 'selected' : ''}>1 Opening</option>
					<option value="2" ${state.numOpenings === 2 ? 'selected' : ''}>2 Openings</option>
					<option value="3" ${state.numOpenings === 3 ? 'selected' : ''}>3 Openings</option>
				  </select>
				</div>

				${state.openings.map((opening, idx) => `
				  <div style="background: #f8f9fa; border: 2px solid #dee2e6; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
					<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; flex-wrap: wrap; gap: 8px;">
					  <h3 style="font-weight: bold; font-size: 18px; margin: 0;">Cab Opening ${idx + 1}</h3>
					  ${opening.handing === 'Center' ? `
						<span style="font-size: 14px; color: #1976d2; font-weight: 600;">ℹ️ Center Opening Doors are Single-Speed Only.</span>
					  ` : ''}
					  ${opening.width === '48' && opening.handing !== 'Center' ? `
						<span style="font-size: 14px; color: #1976d2; font-weight: 600;">ℹ️ 48" Cab Openings use only 2-Speed Doors.</span>
					  ` : ''}
					</div>
					<div class="equipment-grid">
					  <div>
						<label style="display: block; font-size: 14px; font-weight: 600; margin-bottom: 8px;">Door Size *</label>
						<select onchange="updateOpening(${idx}, 'width', this.value)" style="width: 100%; height: 52px; padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
						  <option value="">Select</option>
						  <option value="36" ${opening.width === '36' ? 'selected' : ''}>36"</option>
						  <option value="42" ${opening.width === '42' ? 'selected' : ''}>42"</option>
						  <option value="48" ${opening.width === '48' ? 'selected' : ''}>48"</option>
						</select>
					  </div>
					  <div>
						<label style="display: block; font-size: 14px; font-weight: 600; margin-bottom: 8px;">Door Speed *</label>
						<select onchange="updateOpening(${idx}, 'speed', this.value)" value="${opening.speed || ''}" style="width: 100%; height: 52px; padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;" ${opening.handing === 'Center' ? 'disabled' : ''}>
						  <option value="">Select</option>
						  ${opening.handing === 'Center' ? 
							`<option value="Center" ${opening.speed === 'Center' ? 'selected' : ''}>SSCO</option>` :
							(() => {
							  const speeds = getAvailableSpeeds(opening.width || '36', opening.handing || 'Left');
							  return speeds.map(speed => 
								`<option value="${speed}" ${opening.speed === speed ? 'selected' : ''}>${speed === '1SSO' ? '1SSO' : '2SSO'}</option>`
							  ).join('');
							})()
						  }
						</select>
					  </div>
					  <div>
						<label style="display: block; font-size: 14px; font-weight: 600; margin-bottom: 8px;">Door Hand *</label>
						<select onchange="updateOpening(${idx}, 'handing', this.value)" style="width: 100%; height: 52px; padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
						  <option value="">Select</option>
						  <option value="Left" ${opening.handing === 'Left' ? 'selected' : ''}>Left</option>
						  <option value="Right" ${opening.handing === 'Right' ? 'selected' : ''}>Right</option>
						  <option value="Center" ${opening.handing === 'Center' ? 'selected' : ''}>Center</option>
						</select>
					  </div>
					  <div>
						<label style="display: block; font-size: 14px; font-weight: 600; margin-bottom: 8px;">Hall Kits / Floors *</label>
						<input 
						  type="number" 
						  min="1" 
						  max="100" 
						  id="kits${idx}"
						  placeholder="e.g., 10" 
						  style="width: 100%; height: 52px; padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;"
						>
					  </div>
					</div>
				  </div>
				`).join('')}
			  ` : ''}

			  ${state.step === 2 ? `
				<h2 style="font-size: 28px; font-weight: bold; margin-bottom: 8px; color: #212529;">Job & Contact Information</h2>
				<p style="color: #6c757d; margin-bottom: 24px;">Tell us about your project and how to reach you</p>
				
				<h3 style="font-size: 18px; font-weight: bold; margin-bottom: 16px; color: #212529; margin-top: 24px;">Job Details</h3>
				<div class="form-grid">
				  <input id="jobName" type="text" placeholder="Job Name *" style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
				  <input id="jobNumber" type="text" placeholder="Job Number" style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
				  <input id="city" type="text" placeholder="City *" style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
				  <select id="state" style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px; background: white; cursor: pointer;">
					<option value="">Select State *</option>
					${US_STATES.map(st => `<option value="${st}" ${state.state === st ? 'selected' : ''}>${st}</option>`).join('')}
				  </select>
				</div>
				
				<h3 style="font-size: 18px; font-weight: bold; margin-bottom: 16px; color: #212529; margin-top: 32px;">Contact Information</h3>
				<div class="form-grid">
				  <input id="clientName" type="text" placeholder="Your Name *" style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
				  <input id="company" type="text" placeholder="Company Name *" style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
				  <input id="email" type="email" placeholder="Email Address *" required style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
				  <input id="phone" type="tel" placeholder="Phone Number *" style="padding: 12px 16px; border: 2px solid #dee2e6; border-radius: 8px; font-size: 16px;">
				</div>

				${isEquipmentConfigured ? `
				  <div style="background: #e8f5e9; border: 2px solid #66bb6a; border-radius: 8px; padding: 24px; margin-top: 32px;">
					<h3 style="font-weight: bold; margin-bottom: 16px; font-size: 20px; color: #212529;">Configuration Summary</h3>
					
					<div style="background: white; border-radius: 8px; padding: 20px; margin-bottom: 16px;">
					  <h4 style="font-weight: bold; margin-bottom: 12px; font-size: 16px; color: #212529;">Equipment</h4>
					  ${state.openings.map((opening, idx) => `
						<div style="border-left: 4px solid #ff6b35; padding-left: 16px; margin-bottom: 12px;">
						  <p style="font-weight: 600; margin: 4px 0; font-size: 14px;">Cab Opening ${idx + 1}: ${opening.width}" ${opening.handing} - ${opening.speed === 'Center' ? 'SSCO' : opening.speed}</p>
						  <p style="font-size: 13px; margin: 2px 0; color: #666;">• Operator (×1)</p>
						  <p style="font-size: 13px; margin: 2px 0; color: #666;">• Hall Landing Kits (×${opening.hallLandingKits})</p>
						</div>
					  `).join('')}
					</div>
					
					<div style="background: #212529; color: white; border-radius: 8px; padding: 20px; margin-top: 16px; text-align: center;">
					  <p style="font-size: 16px; margin: 0;">Your detailed estimate with pricing will be sent to your email after submission.</p>
					</div>
				  </div>
				` : ''}
			  ` : ''}

			  <div style="display: flex; justify-content: space-between; margin-top: 32px; gap: 12px; flex-wrap: wrap;">
				${state.step > 1 ? `
				  <button onclick="prevStep()" style="padding: 12px 24px; background: #e9ecef; border: none; border-radius: 8px; font-weight: bold; font-size: 16px; cursor: pointer; flex: 1; min-width: 120px;">← Back</button>
				` : '<div style="flex: 1; min-width: 120px;"></div>'}
				${state.step < 2 ? `
				  <button onclick="nextStep()" style="padding: 12px 24px; background: #ff6b35; color: white; border: none; border-radius: 8px; font-weight: bold; font-size: 16px; cursor: pointer; flex: 1; min-width: 120px;">Next →</button>
				` : `
				  <button onclick="submitEstimate()" ${!isInfoComplete ? 'disabled' : ''} style="padding: 16px 32px; background: ${isInfoComplete ? '#66bb6a' : '#ccc'}; color: white; border: none; border-radius: 8px; font-weight: bold; font-size: 16px; cursor: ${isInfoComplete ? 'pointer' : 'not-allowed'}; flex: 1; min-width: 120px;">Submit Request</button>
				`}
			  </div>
			</div>
		  </div>
		</div>
	  `;
	  
	  const container = document.getElementById('elevator-calculator-root');
	  if (!container) {
		console.error('Calculator container not found!');
		return;
	  }
	  container.innerHTML = html;
	  
	  // Restore focus to the previously focused element
	  if (activeElementId) {
		const elementToFocus = document.getElementById(activeElementId);
		if (elementToFocus) {
		  elementToFocus.focus();
		  // For number inputs, place cursor at the end
		  if (elementToFocus.tagName === 'INPUT' && elementToFocus.type === 'number') {
			setTimeout(() => {
			  elementToFocus.setSelectionRange(elementToFocus.value.length, elementToFocus.value.length);
			}, 0);
		  }
		}
	  }
	  
	  // Add event listeners
	  if (state.step === 2) {
		['jobName', 'jobNumber', 'city', 'state', 'clientName', 'company', 'email', 'phone'].forEach(field => {
		  const el = document.getElementById(field);
		  if (el) {
			el.value = state[field];
			el.addEventListener('input', (e) => {
			  state[field] = e.target.value;
			  render();
			});
			el.addEventListener('change', (e) => {
			  state[field] = e.target.value;
			  render();
			});
		  }
		});
	  }
	  
	  if (state.step === 1) {
		// Add event listeners for hall landing kits inputs
		state.openings.forEach((opening, idx) => {
		  const kitsEl = document.getElementById(`kits${idx}`);
		  if (kitsEl) {
			kitsEl.value = opening.hallLandingKits;
			kitsEl.addEventListener('input', (e) => {
			  state.openings[idx].hallLandingKits = e.target.value;
			  render(); // Re-render for pricing update
			});
		  }
		});
	  }
	}

	// Only render if container exists
	if (document.getElementById('elevator-calculator-root')) {
	  render();
	} else {
	  console.error('Calculator container #elevator-calculator-root not found in DOM');
	}

});